import PropTypes from "prop-types";

import componentType from "./react.proptypes";

const sectionType = PropTypes.shape({
  id: PropTypes.string,
  path: PropTypes.string.isRequired,
  params: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  withStepper: PropTypes.bool.isRequired,
  withDate: PropTypes.bool.isRequired,
  menuText: PropTypes.string,
  menuIcon: componentType,
  step: PropTypes.number,
});

export default sectionType;
